/**
 * @generated SignedSource<<f032d317d26e80fe9dcd680a7d5f271d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCardNew_user$data = {
  readonly backgroundPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly bio: string | null | undefined;
  readonly editorGuildMemberships: {
    readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_GuildMemberships">;
  };
  readonly firstName: string;
  readonly isMe: boolean | null | undefined;
  readonly lastName: string;
  readonly organizerGuildMemberships: {
    readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_GuildMemberships">;
  };
  readonly rowId: string;
  readonly slugId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  readonly " $fragmentType": "UserCardNew_user";
};
export type UserCardNew_user$key = {
  readonly " $data"?: UserCardNew_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "UserCardNew_GuildMemberships"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCardNew_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMe",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhotoNew_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "transform",
              "value": {
                "dpr": 3,
                "fit": "cover",
                "h": 167,
                "w": 500
              }
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":167,\"w\":500})"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "organizerGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "ORGANIZER"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
    },
    {
      "alias": "editorGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "EDITOR"
          }
        },
        (v0/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "aa27c4dd2d3574741502039db33266a4";

export default node;
